<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :close-on-click="true"
    :nudge-right="40"
    :return-value.sync="time"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <ValidationProvider v-slot="{ errors }" :rules="rulesComputed" :name="labelComputed">
        <v-text-field
          ref="self"
          v-model="model"
          v-on="on"
          v-bind="attrs"
          class="text-field-time"
          :label="fullLabel"
          :error-messages="errors"
          :hint="hint"
          :persistent-hint="true"
          :disabled="disabled"
          :clearable="clearable"
          dense
          outlined
          readonly
          hide-details="auto"
          append-icon="mdi-clock-outline"
          @blur="onBlur"
          @change="onChange"
          @click:append="menu = true"
        />
      </ValidationProvider>
    </template>
    <v-time-picker
      v-if="menu"
      ref="picker"
      v-model="model"
      @click:hour="saveHour"
      @click:minute="$refs.menu.save(time)"
      no-title
      scrollable
      ampm-in-title
      format="24hr"
    />
  </v-menu>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import moment from 'moment'

export default {
  name: 'TextFieldInputWithTimePicker',

  components: {
    ValidationProvider,
    moment,
  },

  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: false,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    hint: {
      type: String,
      required: false,
    },
    hourOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data: () => ({
    menu: false,
    time: null,
  }),

  computed: {
    fullLabel() {
      return this.required ? `${this.label} ${this.$t('ELE0024')}` : this.label
    },
    labelComputed() {
      return this.label
    },
    rulesComputed() {
      if (this.required) return 'required'
      else return ''
    },
    model: {
      get() {
        return this.value
      },
      set(value) {
        if (value === null) {
          value = ''
        }
        this.$emit('input', value)
      },
    },
  },

  methods: {
    onBlur() {
      this.$emit('blur')
    },
    onChange() {
      this.$emit('change')
    },
    saveHour() {
      if (this.hourOnly) {
        this.model = String(this.$refs.picker.inputHour).padStart(2, '0') + ':00'
        this.menu = false
      }
    },
  },
}
</script>
<style>
/* 背景色・ボーダー色指定 */
.text-field-time > .v-input__control > .v-input__slot > fieldset {
  background: #edeffd;
  margin-bottom: 2px;
  border-style: solid;
  border-width: 2px;
  border-color: var(--v-primary-base);
}
.text-field-time > .v-input__prepend-outer > .v-input__icon > .v-icon {
  color: var(--v-primary-base);
}
/* フォーカスが外れている場合のラベル色 */
.text-field-time > .v-input__control > .v-input__slot > .v-text-field__slot > .v-label {
  color: var(--v-primary-base);
}
/** エラーメッセージの上端が欠けるのを回避 */
.text-field-time > .v-input__control .v-messages {
  margin-top: 1px;
}
/* 非活性の選択値のボーダー色 */
.text-field-time.v-input--is-disabled > .v-input__control > .v-input__slot > fieldset {
  background: #ffffff;
  border-color: rgba(0, 0, 0, 0.26);
  border-width: 1px;
  color: #000000;
}
/* 非活性のラベル色 */
.text-field-time.v-input--is-disabled > .v-input__control > .v-input__slot > .v-text-field__slot > .v-label {
  color: #000000 !important;
}
/* 非活性の選択値のテキスト色 */
.text-field-time.v-input--is-disabled > .v-input__control > .v-input__slot > .v-text-field__slot > input {
  color: #000000 !important;
}
</style>
